import React, { useState, useEffect } from "react";
import "../../../css/blogs.css"; // Import the CSS file

export const ReadingProgressBar = () => {
  const [readingProgress, setReadingProgress] = useState(0);

  useEffect(() => {
    const updateReadingProgress = () => {
      const currentScrollPos = window.scrollY;
      const scrollHeight =
        document.documentElement.scrollHeight - window.innerHeight;

      if (scrollHeight > 0) {
        // Prevent division by zero
        setReadingProgress((currentScrollPos / scrollHeight) * 100);
      } else {
        setReadingProgress(0); // Handle case where scrollHeight is 0 or less
      }
    };

    window.addEventListener("scroll", updateReadingProgress);

    // Initial call to set progress on load
    updateReadingProgress();

    return () => window.removeEventListener("scroll", updateReadingProgress);
  }, []);

  return (
    <div className="reading-progress-bar-container">
      <div
        className="reading-progress-bar"
        style={{ width: `${readingProgress}%` }} // Only width needs to be dynamic
      />
    </div>
  );
};
